<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/PublicDiscountCodes/Create' }"
              class="vs-component vs-button bg_l_green"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("AddPublicDiscountCode") }}
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('DiscountCode'), sort: 'DiscountCode' },
                { title: $t('Title'), sort: 'Title' },
                { title: $t('StartDate'), sort: 'StartClock' },
                { title: $t('EndDate'), sort: 'ExpireClock' },
                { title: $t('Action'), sort: 'action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 8%">
                  {{ row.code }}
                </td>
                <td style="width: 32%">
                  {{ row.title }}
                </td>
                <td style="width: 16%; direction: ltr">
                  {{ row.expirationInfo.startClock }}
                </td>
                <td style="width: 16%; direction: ltr">
                  {{ row.expirationInfo.expireClock }}
                </td>
                <td style="width: 28%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click.prevent="onShowProductList(row)"
                    >{{ $t("AddItem") }}</vs-button
                  >
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editDiscount(row)"
                    class="ml-4 d-inline"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteSalePlans(row)"
                    class="d-inline"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
          <modify-popup-discount
            :currentDiscount="currentDiscount"
            :show="showModifyPopupDiscount"
            @finish="onfinish"
            @close="closeModifyPopupDiscount"
          ></modify-popup-discount>
          <modify-popup-products
            :currentDiscount="currentDiscount"
            :show="showModifyPopupProducts"
            @finish="onfinish"
            @close="closeModifyPopupProducts"
          ></modify-popup-products>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopupDiscount from "./ModifyPopupDiscount";
import ModifyPopupProducts from "./ModifyPopupProducts";
export default {
  name: "saleManagement_PublicDiscount_Index",
  props: {
    show: { default: false },
  },
  components: {
    DataGrid,
    ModifyPopupDiscount,
    ModifyPopupProducts,
  },
  data() {
    return {
      showModifyPopupProducts: false,
      showModifyPopupDiscount: false,
      discountId: "",
      currentDiscount: "",

      gridDataSource: {
        type: "app",
        service: "Promotion/api/PublicDiscountCodes",
      },

      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    ...mapActions({
      removeDiscount: "voucher/removeDiscount",
    }),

    onShowProductList(row) {
      this.currentDiscount = row;
      this.showProductList = true;
      this.showModifyPopupProducts = true;
    },
    editDiscount(row) {
      this.showModifyPopupDiscount = true;
      this.currentDiscount = row;
    },
    deleteSalePlans(row) {
      this.discountId = row.id;
      this.removeDiscount(this.discountId).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت حذف شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$refs.grid.renderGrid();
      });
    },
    closeModifyPopupDiscount() {
      this.showModifyPopupDiscount = false;
    },
    closeModifyPopupProducts() {
      this.showModifyPopupProducts = false;
    },
    onfinish() {
      this.closeModifyPopupDiscount();
      this.closeModifyPopupProducts();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
